import React, { useEffect, useState } from "react";
import {
  listProducts,
  showDeleteProductModal,
  showUpdateProductModal
} from "../../actions/productActions";
import { useDispatch, useSelector } from "react-redux";
import "./products.css";
import { Flex, Spinner } from "@chakra-ui/react";

import { Helmet } from "react-helmet";
import withNavElements from "../../components/withNavElements";
import SectionHeader from "../../components/SectionHeader";
import ProductsTable from "../../components/ProductsTable";
import TableTools from "../../components/TableTools";
import DeleteProductModal from "../../components/modals/DeleteProductModal";
import CreateProductModal from "../../components/modals/CreateProductModal";
import EditProductModal from "../../components/modals/EditProductModal";

const Products = () => {
  const dispatch = useDispatch();
  const productList = useSelector((state) => state.productList);
  const { loading, error, products } = productList;

  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    dispatch(listProducts());
  }, [dispatch]);

  const deletehandler = (item) => {
    dispatch(showDeleteProductModal(item))
  }

  const editHandler = (item) => {
    dispatch(showUpdateProductModal(item))
  }

  return (
    <Flex
      flexDir="column"
      w="100%"
      minH="80vh"
      pt="120px"
      px={{ base: "40px", md: "40px" }}
    >
      <Helmet>
        <title>Productos - Skyshops</title>
      </Helmet>
      <Flex
        flexDir='column'
      >
        <DeleteProductModal />
        <CreateProductModal />
        <EditProductModal />
        <SectionHeader
          title="Productos"
          description="Crea productos o edita los existentes."
        />

        <TableTools 
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          listProducts={listProducts}
          loading={loading}
        />

        <Flex flex={1} minH='50vh'>
          {loading ? (
            <Flex w='100%' justifyContent='center' py='20px'>
              <Spinner color="black" />
            </Flex>
          ) : (
            <ProductsTable 
              error={error} 
              data={products}
              listProducts={listProducts}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              deletehandler={deletehandler}
              editHandler={editHandler}
            />
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default withNavElements(Products);
